import { render } from "./Anime.vue?vue&type=template&id=d77c7cd2&scoped=true"
import script from "./Anime.vue?vue&type=script&lang=js"
export * from "./Anime.vue?vue&type=script&lang=js"

import "./Anime.vue?vue&type=style&index=0&id=d77c7cd2&scoped=true&lang=css"

import exportComponent from "D:\\CRUD Vue\\Puma Hammasi\\adidas-maincopy\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d77c7cd2"]])

export default __exports__